const kebabArr = [
  [
    'Danie',
    ['mięso', 'surówki', 'frytki', 'sosy', 'cebulka prażona'],
    ['22', '00'],
    1,
  ],
  [
    'Duży Box',
    ['mięso', 'surówka', 'frytki', 'sos', 'cebulka'],
    ['22', '00'],
    2,
  ],
  [
    'Mini Box',
    ['mięso', 'surówka', 'frytki', 'sos', 'cebulka'],
    ['15', '50'],
    3,
  ],
  ['Bułka Duża', ['mięso', 'surówka', 'sos', 'cebulka'], ['21', '00'], 4],
  ['Bułka Mała', ['mięso', 'surówka', 'sos', 'cebulka'], ['15', '50'], 5],
  ['Tortilla Mała', ['mięso', 'surówka', 'sos'], ['15', '50'], 6],
  ['Tortilla Duża', ['mięso', 'surówka', 'sos'], ['19', '50'], 7],
  ['Tortilla Mega', ['mięso', 'surówka', 'sos'], ['26', '00'], 8],
  ['Cheesetilla Mały', ['mięso', 'surówka', 'sos', 'ser'], ['16', '50'], 9],
  ['Cheesetilla Duży', ['mięso', 'surówka', 'sos', 'ser'], ['21', '00'], 10],
  ['Cheesetilla Mega', ['mięso', 'surówka', 'sos', 'ser'], ['28', '50'], 11],
  [
    'Frytotortilla Mały',
    ['mięso', 'surówka', 'frytki', 'sos'],
    ['17', '50'],
    12,
  ],
  [
    'Frytotortilla Duży',
    ['mięso', 'surówka', 'frytki', 'sos'],
    ['22', '00'],
    13,
  ],
  ['Vegetortilla Mały', ['surówka', 'sos'], ['11', '00'], 14],
  ['Vegetortilla Duży', ['surówka', 'sos'], ['13', '00'], 15],
]

export default kebabArr
